import PaymentOptionsList from './PaymentOptionsList';

export default PaymentOptionsList;
